<template>
    <div>
        <div class="table w-full">
            <div class="table-cell w-1 align-middle">
                <slot name="search"></slot>
            </div>
            <div class="table-cell">
                <div class="table w-full">
                    <div class="table-cell">
                        <div class="table w-full bg-white border rounded my-1">
                            <div class="table-cell w-1 align-middle">
                                <div class="sprite-icons-search bg-white"></div>
                            </div>
                            <div class="table-cell align-middle">
                                <input class="text-lg p-2 flex-1 outline-none bg-white w-full" :value="search"
                                       @input="$emit('update:search', $event.srcElement.value)"
                                       @keydown.enter="$emit('search')"/>
                            </div>
                            <div class="table-cell w-1 align-middle">
                                <div class="btn btn-primary" @click="$emit('search')">Search</div>
                            </div>
                            <div class="table-cell w-1 align-middle" v-if="useQueryTable || excelUrl">
                                <div class="btn bg-excel" @click="downloadExcel()">Excel</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <m-table ref="table" :refresh="refreshData" :args="args" @click="(row, index) => $emit('click', row, index)" :initial="initial" :rowBind="rowBind">
            <template slot="header">
                <slot name="header"></slot>
            </template>
            <template v-slot="{row, index}">
                <slot :row="row" :index="index"></slot>
            </template>
        </m-table>
    </div>
</template>
<script>
import Ajax from '@/js/ajax.js'

export default {
    props: {
        rowBind: Function,
        search: String,
        url: String,
        args: {
            type: Object,
            default: () => ({})
        },
        excelUrl: String,
        useQueryTable: {
            type: Boolean,
            default: true
        },
        filter: Function,
        interceptor: Function,
        initial: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        downloadExcel() {
            const url = this.excelUrl 
            ? this.excelUrl 
            : this.useQueryTable
                ? `/querytable/${this.url}/excel`
                : this.url
            Ajax.download(url, this.args)
        },
        refresh() {
            this.$refs.table.refreshData();
        },
        refreshTable() {
            this.$refs.table.refreshData();
        },
        refreshData(page, rows, args) {
            const url = this.useQueryTable
                ? `/querytable/${this.url}/query`
                : this.url
            return Ajax.post(url, {
                page: page,
                rowsPerPage: rows,
                ...args
            }, false).then(resp => {
                // Intercept the whole response
                // Sometimes response is not pagenation response
                resp = this.interceptor ? this.interceptor(resp) : resp
                var data = {
                    count: resp.total,
                    data: this.filter ? this.filter(resp.items) : resp.items
                }
                return data
            })
        }
    }
};
</script>
